import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, ChangeDetectorRef } from '@angular/core';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';
import {
    BehaviorSubject,
    delay,
    filter,
    merge,
    Observable,
    ReplaySubject,
    Subject,
    Subscription,
    takeUntil,
    switchMap,
    map,
    catchError,
    of,
    throwError,
    EMPTY,
} from 'rxjs';
import { LinkService } from 'app/_helpers/link-service.service';
import { NavigationExtras } from '@angular/router';
import { LogoParrainComponent } from '../logo-parrain/logo-parrain.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ParrainStore } from 'app/modules/admin/stores/parrain.store';
import { ParrainAnnonceService } from 'app/_services/parrain-annonce.service';
import { ParrainNavigationService } from 'app/_services/parrain-navigation.service';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        RouterModule,
        RouterLinkActive,
        LogoParrainComponent,
    ],
})
export class FooterComponent {
    private _linkService = inject(LinkService);
    private _fuseNavigationService = inject(FuseNavigationService);
    private _router = inject(Router);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _parrainAnnonceService = inject(ParrainAnnonceService);
    readonly parrainStore = inject(ParrainStore);
    private _parrainNav = inject(ParrainNavigationService);
    onClick(url: string) {
        this.sendMessage({ url: url });
        this._linkService.openLinkInNativeView(url);
    }

    sendMessage(data: { url: string }) {
        const message = JSON.stringify(data);
        window.postMessage(message, '*');
    }

    toggleNavigation(name: string): void {
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );
        if (navigation) {
            navigation.toggle();
        }
    }
    onShowParrainSpace(sponsorId?: string | null): void {
        if (!sponsorId) return;
        this._parrainNav.onShowParrainSpace(sponsorId);
        this._changeDetectorRef.markForCheck();
    }
    // private navigateAndClose(commands: any[], extras?: NavigationExtras) {
    //     this._router.navigate(commands, extras).then(() => {
    //         this._changeDetectorRef.markForCheck();
    //     });
    // }

    // onShowParrainSpace(sponsorId: string): void {
    //     this._parrainAnnonceService
    //         .getParrainIdBySponsorId(sponsorId)
    //         .pipe(
    //             // 404 -> on va direct sur la page détail (fallback)
    //             catchError((err) => {
    //                 if (err?.status === 404) {
    //                     this.navigateAndClose([
    //                         '/partenaire-detail',
    //                         sponsorId,
    //                     ]);
    //                     return EMPTY;
    //                 }
    //                 return throwError(() => err);
    //             }),
    //             switchMap((parrainId) => {
    //                 if (!parrainId) {
    //                     // Aucun lien trouvé, même traitement que 404
    //                     this.navigateAndClose([
    //                         '/partenaire-detail',
    //                         sponsorId,
    //                     ]);
    //                     return EMPTY;
    //                 }
    //                 // Sinon on cherche l’annonce approuvée
    //                 return this._parrainAnnonceService
    //                     .getAnnonceApprouveeByParrainId(parrainId)
    //                     .pipe(
    //                         map((annonce) => ({ parrainId, annonce })),
    //                         // si 404 sur l’annonce -> on va au détail parrain
    //                         catchError(() => of({ parrainId, annonce: null }))
    //                     );
    //             })
    //         )
    //         .subscribe(({ parrainId, annonce }) => {
    //             if (annonce) {
    //                 this.navigateAndClose(['/pub-parrain', annonce.id], {
    //                     queryParams: { sponsorId },
    //                 });
    //             } else {
    //                 this.navigateAndClose(['/partenaire-detail', parrainId]);
    //             }
    //         });
    // }
}
